export const ariaAttr = condition => condition ? true : undefined;
//# sourceMappingURL=accessibilityUtils.js.map